import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/idp/base';
import type { Activity } from '@/data/idp/plans/interfaces';

export const usePlanActivitiesIndex = (planId: string | undefined) => {
  const result = useQuery<{ activities: Activity[] }>({
    enabled: !!planId,
    queryKey: [clientKeys.usePlanActivitiesIndex, planId],
    queryFn: async () =>
      falconClient.get(`${baseUrl}/plans/${planId}/activities`),
  });

  const activities = result.data?.activities || [];
  return { activities, ...result };
};

export const useDeletePlanActivity = (planId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ activityId }: { activityId: string }) =>
      falconClient.delete(
        `${baseUrl}/plans/${planId}/activities/${activityId}`
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.usePlanShow, planId],
      });
    },
  });
};
